import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

interface HeroSectionProps {
  scrollY: number;
}

export default function HeroSection({ scrollY }: HeroSectionProps) {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  return (
    <section id="home" className="relative min-h-screen flex items-center justify-center bg-black overflow-hidden pt-16 md:pt-0">
      <div 
        className="absolute inset-0 bg-black"
        style={{ transform: `translateY(${scrollY * 0.5}px)` }}
      ></div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 lg:px-8">
        <div className={`text-center mb-8 transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
          <h2 className="text-base md:text-xl font-light text-orange-400 mb-4 tracking-wide">
            A Journey Through the Web. A Story of Us
          </h2>
          
          <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold mb-6 leading-tight">
            <span className="bg-gradient-to-r from-white via-orange-200 to-orange-400 bg-clip-text text-transparent">
              Reimagine Your
            </span>
            <br />
            <span className="bg-gradient-to-r from-orange-400 to-red-500 bg-clip-text text-transparent">
              Digital Future.
            </span>
            <br />
            <span className="text-white">With Us.</span>
          </h1>

          <p className="text-xl md:text-2xl text-gray-300 mb-8 max-w-4xl mx-auto leading-relaxed">
            From pixelated beginnings to AI-powered possibilities – Welcome to the world of <strong>Hash Adz</strong>.
          </p>

          <div className="max-w-5xl mx-auto mb-12">
            <p className="text-lg md:text-xl text-gray-200 leading-relaxed">
              Welcome to <strong>Hash Adz</strong>, a digital consultancy born in the vibrant landscape of <strong>Kochi, Kerala</strong>. 
              We've journeyed alongside the internet's evolution, from its foundational stages to the dynamic, 
              intelligent era of Artificial Intelligence. Today, we empower businesses to not just navigate, 
              but lead in the digital realm.
            </p>
          </div>

          <div className="flex flex-col sm:flex-row gap-6 justify-center items-center">
            <Link to="/services" className="w-full sm:w-auto group bg-gradient-to-r from-orange-500 to-red-600 hover:from-orange-600 hover:to-red-700 text-white px-8 py-4 rounded-full font-semibold text-lg transition-all duration-300 transform hover:scale-105 hover:shadow-2xl whitespace-nowrap cursor-pointer">
              <span className="flex items-center justify-center gap-3">
                Explore Our Solutions
                <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform duration-300"></i>
              </span>
            </Link>
            
            <Link to="/contact" className="w-full sm:w-auto group border-2 border-orange-500 text-orange-400 hover:bg-orange-500 hover:text-white px-8 py-4 rounded-full font-semibold text-lg transition-all duration-300 transform hover:scale-105 whitespace-nowrap cursor-pointer">
              <span className="flex items-center justify-center gap-3">
                <i className="ri-calendar-line"></i>
                Schedule a Discovery Call
              </span>
            </Link>
          </div>
        </div>
      </div>

      <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-orange-400 text-2xl"></i>
      </div>
    </section>
  );
}